
import {Vue} from "vue-class-component";

export default class ThePreloader extends Vue {
}
